
type DataLayerEvent = {
  event: string;
  [key: string]: unknown; // Allow other dynamic properties
};

declare global {
  interface Window {
    dataLayer: DataLayerEvent[]; // Array of specific event objects
  }
}
export const pushToDataLayer = (eventName :string, eventData = {}) => {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push({
      event: eventName,
      ...eventData
    });
  } else {
    console.warn('GTM dataLayer is not initialized.');
  }
};
